import { useQuery } from "react-query";
import {
  getAudienceCustomers,
  getAudienceDetails,
  getAudiences,
  getSmsCampaignDetails,
  getSmsCampaigns,
} from "../../../services/marketing";

export const useGetSmsCampaigns = ({ queries = "", queryParams = {} }) => {
  return useQuery(
    ["getSmsCampaigns", queries, queryParams],
    () => getSmsCampaigns(queries, queryParams).then((res) => res?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetSmsCampaignDetails = ({ id }) => {
  return useQuery(
    ["getSmsCampaignDetails", `${id}`],
    () => getSmsCampaignDetails(id).then((res) => res?.data?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetAudiences = ({ queries = "", queryParams = {} }) => {
  return useQuery(
    ["getAudiences", queries, queryParams],
    () => getAudiences(queries, queryParams).then((res) => res?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetAudienceDetails = ({ id }) => {
  return useQuery(
    ["getAudienceDetails", `${id}`],
    () => getAudienceDetails(id).then((res) => res?.data?.data),
    {
      staleTime: Infinity,
    },
  );
};

export const useGetAudienceCustomers = ({
  id,
  queryParams = {},
  isEnabled = true,
}) => {
  return useQuery(
    ["getAudienceCustomers", `${id}`, queryParams],
    () => getAudienceCustomers(id, queryParams).then((res) => res?.data),
    {
      staleTime: Infinity,
      enabled: isEnabled,
    },
  );
};
